// Store pagination constants
export const STORE_LIMIT = 50;
export const STORE_OFFSET = 0;

// Time range constants
export const DEFAULT_MONTH_RANGE = 6;

// Date formatting constants
export const TRIM_CURRENT_DATE = 16;
export const PADSTART = 2;

// Index constants
export const FIRST_INDEX = 0;

// Numeric constants
export const ONE_VALUE = 1;

// Max description length
export const MAX_DESCRIPTION_LENGTH = 200;

// Table column widths for last runs config
export const LAST_RUNS_CONFIG = {
  BusinessDay: 80,
  BDInstance: 30,
  IsManualTrigger: 50,
  IsScheduleTrigger: 50,
  ReconciliationRunStatusTag: 50,
  TotalInTransitRecords: 40,
  TotalExceptionRecords: 60,
};

// Column Sizes and UI Constants
export const COLUMN_SIZES = {
  STATUS: 150,
  STREAM_NAME: 180,
  SCHEDULED: 99,
  PERIODICITY_NAME: 170,
  NEXT_RUN: 120,
  LAST_SUCCESSFUL_RUN: 120,
  LAST_DURATION: 120,
};

// Pinning Initial State
export const PINNING_INITIAL_STATE = ["pin"];

// Table Configuration
export const TABLE_CONFIG = {
  maxHeight: "calc(100dvh - 330px)",
  pinnedRowHeight: 57,
  prefix: "ReconciliationStreams",
  showFilter: false,
};

// Legend Data Constants
export const LEGEND_DATA = [];
export const LEGEND_HIDE_TAGS = ["COMPLETED", "FAILED"];

// Cell Display Constants - Scheduled column
export const SCHEDULED_CHECK_MARK = "✓";
export const SCHEDULED_X_MARK = "𝗫";
export const SCHEDULED_CELL_PADDING = "px-3";

// Status cell configuration
export const STATUS_CHECK_VALUES = ["INPROGRESS"];
